module.exports = __webpack_public_path__ + "img/C06TechSiegeTowerChampion_ua.3a86b6a7.webp";